import { createTheme } from '@material-ui/core/styles';

// export const tableTheme = createTheme({
//   overrides: {
//     MUIDataTable: {
//       paper: {
//         borderRadius: 10,
//         background: "white",
//       },
//     },
//     MUIDataTableHeadRow: {
//       // root
//     },
//     MuiToolbar: {
//       regular: {
//         fontWeight: "bold",
//       },
//     },

//     MUIDataTableBodyCell: {
//       root: {
//         fontWeight: "500",
//         cursor: "pointer",
//         justifyContent: "center",
//       },
//     },
//     MUIDataTableHeadCell: {
//       data: {
//         fontWeight: "800",
//       },
//       toolButton: {
//         justifyContent: "center",
//       },
//     },

//     MUIDataTableSelectCell: {
//       root: {
//         display: "none",
//       },
//     },
//   },
// });

export const tableTheme = createTheme({
  overrides: {
    MUIDataTable: {
      paper: {
        borderRadius: 10,
        background: 'white',
      },
    },
    MUIDataTableToolbar: {
      actions: {
        display: 'flex',
        flexDirection: 'row-reverse',
        alignItems:"center"
      },
    },
    MUIDataTableBodyCell: {
      root: {
        fontWeight: '600',
        cursor: 'pointer',
      },
    },
    MUIDataTableHeadCell: {
      // root: {
      //   fontWeight: '900',
      // },
    },
    MUIDataTableSelectCell: {
      root: {
        display: 'none',
      },
    },
  },
});
export const tableThemeCheckbox = createTheme({
  overrides: {
    MUIDataTable: {
      paper: {
        borderRadius: 10,
        background: 'white',
      },
    },
    MUIDataTableBodyCell: {
      root: {
        fontWeight: '600',
        cursor: 'pointer',
      },
    },
    MUIDataTableHeadCell: {
      // root: {
      //   fontWeight: '900',
      // },
    },
  },
});

export const tableThemeStatic = createTheme({
  overrides: {
    MUIDataTable: {
      paper: {
        borderRadius: 10,
        background: 'white',
      },
    },
    MUIDataTableBodyCell: {
      root: {
        fontWeight: '600',
        // height: "16px",
      },
    },
    MUIDataTableHeadCell: {
      root: {
        fontWeight: '400',
      },
    },

    MUIDataTableSelectCell: {
      root: {
        display: 'none',
      },
    },
  },
});
